import { gql } from "config/graphql";

export const DOCUMENTS_FILE_FIELDS = gql`
  fragment DocumentsFileFields on DocumentsFile {
    fileName
    url
  }
`;

export const DOCUMENT_FIELDS = gql`
  ${DOCUMENTS_FILE_FIELDS}
  fragment DocumentFields on Document {
    applicableYear
    createdAt
    documentCategory {
      name
      slug
    }
    files {
      ...DocumentsFileFields
    }
    html {
      ...DocumentsFileFields
    }
    id
    jpeg {
      ...DocumentsFileFields
    }
    name
    pdf {
      ...DocumentsFileFields
    }
    png {
      ...DocumentsFileFields
    }
    slug
    updatedAt
    version
  }
`;
